<page-heading
  [title]="'response.automatic.pageTitle' | translate"
  [description]="'response.automatic.pageDescription' | translate"
/>

@if (list.length === 0) {
  <empty-records-legacy-component
    [message]="'response.automatic.emptyMessage' | translate"
    [subMessage]="'response.automatic.emptySubMessage' | translate">
  </empty-records-legacy-component>
}

@if (list.length > 0) {
  @if (acceptsAttachment) {
    <div class="alert alert-primary d-flex align-items-start gap-2 mb-3" role="alert">
      <i class="ri-information-line font-18 lh-1"></i>
      <span
        [innerHTML]="(captionLimit ? 'response.automatic.attachment.alertLimit' : 'response.automatic.attachment.alert') | translate: { limit: (captionLimit | number) }">
      </span>
    </div>
  }

  <div class="container-fluid px-0">
    <div class="row g-3 mb-0 w-100">
      @for (item of list; track $index) {
        <div class="col-12 col-sm-6 col-xl-4">
          <div class="card">
            <div class="card-body">
              <div class="w-full">
          </div>
            <div class="d-flex justify-content-between align-items-center mb-1">
              <label class="font-semibold flex gap-1 items-center text-black">{{ item.header }}</label>
              <div class="custom-switch">
                <input
                  type="checkbox"
                  [id]="'activated-' + $index"
                  data-switch="success"
                  [(ngModel)]="item.activated"
                  (ngModelChange)="onItemChange()"
                />
                <label [for]="'activated-' + $index"></label>
              </div>
            </div>

            @if (!item.midia) {
              <textarea
                class="form-control mb-1"
                rows="8"
                [placeholder]="'response.automatic.contentPlaceholder' | translate"
                [(ngModel)]="item.message"
                (ngModelChange)="onItemChange()"
                #textarea>
              </textarea>

              <div class="d-flex g-1 justify-content-end align-items-center">
                <button
                  type="button"
                  class="btn btn-sm p-2 d-flex align-items-center justify-content-center"
                  (click)="applyFormat('bold', $index, textarea)"
                  [title]="'response.automatic.bold' | translate">
                  <i class="ri-bold"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-sm p-2 d-flex align-items-center justify-content-center"
                  (click)="applyFormat('italic', $index, textarea)"
                  [title]="'response.automatic.italic' | translate">
                  <i class="ri-italic"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-sm p-2 d-flex align-items-center justify-content-center"
                  (click)="applyFormat('strikethrough', $index, textarea)"
                  [title]="'response.automatic.strikethrough' | translate">
                  <i class="ri-strikethrough"></i>
                </button>

                <button
                  type="button"
                  class="btn btn-sm p-2 d-flex align-items-center justify-content-center"
                  (click)="toogleContainerEmoji($index)"
                  [title]="'response.automatic.emojis' | translate">
                  <i class="ri-emotion-happy-line"></i>
                </button>

                <div class="dropdown">
                  <button
                    class="btn btn-sm p-2 d-flex align-items-center justify-content-center"
                    type="button"
                    [id]="'variablesDropdown-' + $index"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    [title]="'response.automatic.variables' | translate"
                  >
                    <i class="ri-code-line"></i>
                  </button>
                  <ul class="dropdown-menu" [attr.aria-labelledby]="'variablesDropdown-' + $index">
                    @for (variable of templateVariableResponseAutomatedList; track variable.value) {
                      <li>
                        <a class="dropdown-item" href="#" (click)="setVariableInContent(variable.value, $index); $event.preventDefault()">
                          <i class="ri-{{ variable.icon }} me-2"></i>
                          {{ variable.label }}
                        </a>
                      </li>
                    }
                  </ul>
                </div>

                @if (acceptsAttachment) {
                  <div class="dropdown">
                    <button
                      class="btn btn-sm p-2 d-flex align-items-center justify-content-center text-primary"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      [title]="'response.automatic.attachment.attach' | translate"
                      [attr.aria-label]="'response.automatic.attachment.attach' | translate"
                    >
                      <i class="ri-attachment-2"></i>
                    </button>
                    <ng-container *ngTemplateOutlet="attachMenu; context: { $implicit: $index }" />
                  </div>
                }
              </div>

              <div class="position-relative">
                @if (showContainerEmojiIndex === $index) {
                  <div class="position-absolute top-0 end-0 z-index-1000">
                    <emoji-mart
                      (emojiSelect)="addEmoji($event, $index)"
                      [darkMode]="false"
                      [ngClass]="getStyleContainerEmoji($index)">
                    </emoji-mart>
                  </div>
                }
              </div>
            } @else {
              <div class="border rounded bg-light p-2">
                @if (isImage(item)) {
                  <div class="d-flex align-items-center gap-2">
                    <img
                      class="avatar-lg rounded object-fit-cover flex-shrink-0"
                      [src]="item.midia"
                      [alt]="'response.automatic.attachment.imageAlt' | translate"
                      (error)="onImageError($event)" />
                    <div class="d-flex flex-column">
                      <span class="fw-bold text-dark text-break">{{ item.filename }}</span>
                      <small class="text-muted">{{ attachmentMeta(item) }}</small>
                    </div>
                  </div>
                } @else {
                  <div class="d-flex align-items-center gap-2">
                    <div class="avatar-md flex-shrink-0">
                      <span class="avatar-title rounded bg-primary-subtle text-primary fw-bold">{{ extensionOf(item) }}</span>
                    </div>
                    <div class="d-flex flex-column">
                      <span class="fw-bold text-dark text-break">{{ item.filename }}</span>
                      <small class="text-muted">{{ attachmentMeta(item) }}</small>
                    </div>
                  </div>
                }
                <p class="mb-0 mt-2 pt-2 border-top text-dark text-break whitespace-pre-line">{{ item.message }}</p>
              </div>

              <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-2">
                <small class="text-muted">
                  @if (captionLimit) {
                    {{ 'response.automatic.attachment.captionCounter' | translate: { count: item.message?.length ?? 0, limit: (captionLimit | number) } }}
                  }
                </small>
                <div class="d-flex align-items-center gap-1">
                  <button type="button" class="btn btn-outline-primary" (click)="editCaption($index)">
                    <i class="ri-pencil-line me-1"></i>{{ 'response.automatic.attachment.editCaption' | translate }}
                  </button>
                  <div class="dropdown">
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      [title]="'response.automatic.attachment.replace' | translate"
                      [attr.aria-label]="'response.automatic.attachment.replace' | translate">
                      <i class="ri-refresh-line"></i>
                    </button>
                    <ng-container *ngTemplateOutlet="attachMenu; context: { $implicit: $index }" />
                  </div>
                  <button
                    type="button"
                    class="btn btn-outline-danger"
                    [title]="'response.automatic.attachment.remove' | translate"
                    [attr.aria-label]="'response.automatic.attachment.remove' | translate"
                    (click)="removeAttachment($index)">
                    <i class="ri-delete-bin-line"></i>
                  </button>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
    </div>
  </div>

  <ng-template #attachMenu let-index>
    <ul class="dropdown-menu dropdown-menu-end">
      <li>
        <button type="button" class="dropdown-item d-flex align-items-center gap-2 py-2" (click)="pickFile(index, imageType)">
          <i class="ri-image-line text-primary font-18"></i>
          <span class="d-flex flex-column">
            <span class="fw-bold">{{ 'response.automatic.attachment.image' | translate }}</span>
            <small class="text-muted">{{ 'response.automatic.attachment.imageHint' | translate }}</small>
          </span>
        </button>
      </li>
      <li>
        <button type="button" class="dropdown-item d-flex align-items-center gap-2 py-2" (click)="pickFile(index, documentType)">
          <i class="ri-file-text-line text-primary font-18"></i>
          <span class="d-flex flex-column">
            <span class="fw-bold">{{ 'response.automatic.attachment.document' | translate }}</span>
            <small class="text-muted">{{ 'response.automatic.attachment.documentHint' | translate }}</small>
          </span>
        </button>
      </li>
    </ul>
  </ng-template>

  <input #imageInput type="file" class="d-none" [accept]="acceptFor(imageType)" (change)="onFileChosen($event)" />
  <input #documentInput type="file" class="d-none" [accept]="acceptFor(documentType)" (change)="onFileChosen($event)" />

  <div class="row">
    <div class="col-12 d-flex justify-content-end mt-3 mb-3">
      <button
        type="button"
        class="btn btn-primary fw-bold"
        (click)="updateAll()"
        [disabled]="!hasChanges()">
        {{ !loading ? ('response.automatic.save' | translate) : "" }}
        @if (loading) {
          <mat-spinner [diameter]="15" [color]="'accent'" mode="indeterminate" />
        }
      </button>
    </div>
  </div>
}
